import React, { useEffect } from "react";

import "./App.css";
import { ZoomMtg } from "@zoom/meetingsdk";
import ApplyCSSOverrides from "./ApplyCSSOverrides";
import JitsiMeetingView from "./JitsiMeetingView";

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

const App = () => {
  const params = new URL(document.location.toString()).searchParams;
  const platform = params.get("platform") || "zoom";
  const meetingID = params.get("meetingId");
  const meetingPwd = params.get("meetingPwd");
  const user_id = params.get("userId");
  const uName = params.get("userName");
  const meetingType = params.get("meetingType") || "webinar";
  const zoomSignatureEndPoint = process.env.REACT_APP_ZOOM_SIGNATURE_END_POINT;
  const zoomSdkKey = process.env.REACT_APP_ZOOM_MEETING_SDK_KEY;
  const cleanString = (inputString) => {
    return inputString.replace(/[^a-zA-Z0-9]/g, ""); // Remove special characters and spaces
  };

  var authEndpoint = zoomSignatureEndPoint;
  var sdkKey = zoomSdkKey;
  var meetingNumber = meetingID;
  var passWord = meetingPwd;
  var role = 0;
  var userName = uName;
  var userEmail = `${cleanString(uName)}_${user_id}@gmail.com`;
  var registrantToken = "";
  var zakToken = "";
  var leaveUrl = "http://localhost:3000";

  useEffect(() => {
    if (platform === 'zoom') {
      getSignature();
    }
  }, [platform]);

  const getSignature = async () => {
    fetch(authEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        meetingNumber: meetingNumber,
        role: role,
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        startMeeting(response.signature);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  function startMeeting(signature) {
    document.getElementById("zmmtg-root").style.display = "block";

    ZoomMtg.init({
      leaveUrl: leaveUrl,
      patchJsMedia: true,
      leaveOnPageUnload: true,
      disablePreview: true,
      isLockBottom: true,
      isSupportQA:false,
      success: (success) => {
        console.log(success);

        ZoomMtg.join({
          signature: signature,
          sdkKey: sdkKey,
          meetingNumber: meetingNumber,
          passWord: passWord,
          userName: userName,
          userEmail: userEmail,
          tk: registrantToken,
          zak: zakToken,
          success: (success) => {
            console.log(success);
          },
          error: (error) => {
            console.log(error);
          },
        });
      },
      error: (error) => {
        console.log(error);
      },
    });
    ZoomMtg.inMeetingServiceListener("onMeetingStatus", function (data) {
      if (data?.meetingStatus === 3) {
        window?.ReactNativeWebView.postMessage("closed");
      }
    });
  }

  const handleJitsiMeetingEnd = () => {
    window?.ReactNativeWebView.postMessage("closed");
  }

  return (
    <>
      {platform === 'zoom' && (
        <>
          <ApplyCSSOverrides type={meetingType} />
          <div className="App"></div>
        </>
      )}
      
      {platform === 'jitsi' && (
        <JitsiMeetingView
        userName={uName}
        roomName={meetingID}
        onMeetingEnd={handleJitsiMeetingEnd}
        meetingType={meetingType}
         />
      )}
    </>
  );
};

export default App;
